import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { ViError } from '../../../projects/client';
import {
  GATEWAY_COMMISSIONING_DEVICE,
  GATEWAY_COMMISSIONING_FLOW,
  GATEWAY_COMMISSIONING_STEP,
  TransferInstallationFormData,
  VerifyGatewayResponse,
} from './gateway-commissioning.model';

export namespace GatewayCommissioningActions {
  export const setActiveStep = createAction(
    '[GATEWAY COMMISSIONING] Set Active Step',
    props<{
      activeStep: GATEWAY_COMMISSIONING_STEP;
    }>()
  );

  export const setFormData = createAction(
    '[GATEWAY COMMISSIONING] Set Form Data',
    props<{
      formData: TransferInstallationFormData;
    }>()
  );

  export const setSelectedDevice = createAction(
    '[GATEWAY COMMISSIONING] Set Selected Device',
    props<{
      selectedDevice: GATEWAY_COMMISSIONING_DEVICE;
    }>()
  );

  export const setCommissioningFlow = createAction(
    '[GATEWAY COMMISSIONING] Set Commissioning Flow',
    props<{
      commissioningFlow: GATEWAY_COMMISSIONING_FLOW;
    }>()
  );

  export const registerGateway = createActionGroup({
    source: '[GATEWAY COMMISSIONING] Register Gateway',
    events: {
      attempt: props<{ payload: { withoutOwner: boolean } }>(),
      success: props<{ withoutOwner: boolean }>(),
      failed: emptyProps(),
    },
  });

  export const commercialRegisterGateway = createActionGroup({
    source: '[GATEWAY COMMISSIONING] Commercial Register Gateway',
    events: {
      attempt: props<{ payload: { withoutInvitation: boolean } }>(),
      success: emptyProps(),
      failed: emptyProps(),
    },
  });

  export const sendInvitation = createActionGroup({
    source: '[GATEWAY COMMISSIONING] Send Invitation',
    events: {
      attempt: props<{
        installationId: number;
        inviteeEmail: string;
      }>(),
      success: emptyProps(),
      failed: emptyProps(),
    },
  });

  export const createInvitation = createAction(
    '[GATEWAY COMMISSIONING] create  invitation',
    props<{
      installationId: number;
      inviteeEmail: string;
    }>()
  );

  export const resendInvitation = createAction(
    '[GATEWAY COMMISSIONING] resend invitation',
    props<{
      invitationToCancel: {
        invitationToken: string;
      };
      invitationToCreate: {
        installationId: number;
        inviteeEmail: string;
      };
    }>()
  );

  export const verifyGateway = createActionGroup({
    source: '[GATEWAY COMMISSIONING] verify gateway',
    events: {
      attempt: props<{ gatewaySerial: string; gatewayPassword: string }>(),
      success: props<{ verifyGateway: VerifyGatewayResponse }>(),
      failed: props<{ error: ViError | unknown }>(),
    },
  });

  export const clearState = createAction('[GATEWAY COMMISSIONING] clear state');
}
